// extracted by mini-css-extract-plugin
export default {"inputHolder":"styles_inputHolder__sgXVw","passwordHolder":"styles_passwordHolder__+gQI3","authForm":"styles_authForm__BpAWQ","togglePassword":"styles_togglePassword__dgrhO"};